import { request } from "../services/Request";
import { routes } from "../constants/constant.route";
import { urlConstants } from "../utils/urlConstants";

const { CALENDER } = routes.CALENDER;
const {API_URL} = urlConstants;

export default class CalendarService {
  static getCalendarEventDetails(body) {
    return request("GET", `${API_URL}${CALENDER}`, null, body, null, null);
  }
}
